<script lang="ts">
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24.468">
	<path
		class:hover
		class:active
		d="M561.893 219.915a10 10 0 0 0-19.991.417v.052a9.2 9.2 0 0 0 2.455 6.1l7.543 8.316 7.547-8.32a9.194 9.194 0 0 0 2.45-6.038q.003-.264-.004-.527zm-9.7 6.616a6.48 6.48 0 1 1 6.178-6.768 6.48 6.48 0 0 1-6.171 6.767z"
		transform="translate(-541.902 -210.329)" />
</svg>

<style lang="scss">
	path {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
